import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";
import ViewLeave from "./view";
import EditLeave from "./edit";
import { MODULE_OVERTIME_REQUESTS } from "variables/modules";
import OvertimeRequests from "./index";

const overtimesRequestRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Overtime Requests",
		basePath: "overtime-requests",
		mainComponent: <OvertimeRequests />,
	    layout: "/console",	   
	    subTitle:"Overtime Request",
	    viewComponent: <ViewLeave />,
	    createComponent: <EditLeave />,
	    editComponent: <EditLeave />,
		level:4,
		moduleId: MODULE_OVERTIME_REQUESTS,
	})
]

export default overtimesRequestRoutes;